export default __webpack_public_path__ + "static/media/logo-vitrine.b17854b3.png";